import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, isRef as _isRef, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-content-center" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card bg-white border-0 rounded-3 mb-4" }
const _hoisted_4 = { class: "card-body p-4" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = { class: "position-relative" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "col-lg-6" }
const _hoisted_11 = { class: "form-group" }
const _hoisted_12 = { class: "position-relative" }
const _hoisted_13 = { class: "text-danger" }
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = { class: "position-relative" }
const _hoisted_17 = { class: "text-danger" }
const _hoisted_18 = { class: "col-lg-3" }
const _hoisted_19 = { class: "form-group" }
const _hoisted_20 = { class: "text-danger" }
const _hoisted_21 = { class: "col-lg-3" }
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = { class: "position-relative" }
const _hoisted_24 = { class: "text-danger" }

import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import { useField, useForm } from "vee-validate";
import { toTypedSchema } from "@vee-validate/zod";
import * as zod from "zod";
import { onMounted, ref } from "vue";
import router from "@/router";
import BaseLoading from "@/components/Common/BaseLoading.vue";
import { toast } from "vue-sonner";
import {
  VendorDataPayload,
  VendorDataResponse,
} from "@/types/interface/vendor";
import { useVendorStore } from "@/stores/master/vendor";


export default /*@__PURE__*/_defineComponent({
  __name: 'CreateVendor',
  setup(__props) {

const idVendor = ref<string>("");
const isEdit = ref<boolean>(false);
const isLoading = ref<boolean>(false);
const vendorStore = useVendorStore();
const detailVendor = ref<VendorDataResponse>();

const listPhoneCode = [
  { value: "60", label: "+60 - Malaysia" },
  { value: "62", label: "+62 - Indonesia" },
];

const phoneCodeSchema = zod
  .object({
    value: zod.string(),
    label: zod.string(),
  })
  .refine(
    (data) =>
      listPhoneCode.some(
        (code) => code.value === data.value && code.label === data.label
      ),
    {
      message: "Invalid phone code selected",
    }
  );

const validationSchema = toTypedSchema(
  zod.object({
    name: zod.string().nonempty({ message: "Name is required" }),
    address: zod.string().nonempty({ message: "Address is required" }),
    phone_code: phoneCodeSchema,
    phone_number: zod
      .string()
      .nonempty({ message: "Phone Number is required" }),
    email: zod.string().nonempty({ message: "Email is required" }),
  })
);

const { handleSubmit, errors } = useForm({
  validationSchema,
});

const { value: name } = useField<string>("name");
const { value: address } = useField<string>("address");
const { value: phone_code } = useField<string>("phone_code");
const { value: phone_number } = useField<string>("phone_number");
const { value: email } = useField<string>("email");

const onSubmit = handleSubmit(async (values) => {
  isLoading.value = true;
  const payloadVendor: VendorDataPayload = {
    name: name.value,
    address: address.value,
    phone_code: phone_code.value?.value,
    phone_number: phone_number.value,
    email: email.value,
  };

  const responseApi = ref<any>();

  if (isEdit.value == true) {
    responseApi.value = await vendorStore.dispatchUpdate(
      idVendor.value,
      payloadVendor
    );
  } else {
    responseApi.value = await vendorStore.dispatchCreate(payloadVendor);
  }

  const { success, message } = responseApi.value;
  if (success == true) {
    setTimeout(() => {
      isLoading.value = false;
      toast.success(
        isEdit.value
          ? "Vendor Successfully Updated"
          : "Vendor Successfully Added"
      );
      router.push("/master/vendor");
    }, 1000);
  } else {
    isLoading.value = false;
    toast.error(message);
  }
});

const loadDetailVendor = async () => {
  const { success, message } = await vendorStore.dispatchDetail(idVendor.value);
  if (success) {
    detailVendor.value = await vendorStore?.vendor?.data;
    name.value = detailVendor.value?.name;
    address.value = detailVendor.value?.address;
    phone_code.value = { value: "62", label: "+62 - Indonesia" };
    phone_number.value = detailVendor.value?.phone_number;
    email.value = detailVendor.value?.email;
  }
};

onMounted(() => {
  if (router.currentRoute.value.params.id != undefined) {
    isEdit.value = true;
    idVendor.value = router.currentRoute.value.params.id.toString();
    loadDetailVendor();
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "d-flex justify-content-between align-items-center flex-wrap gap-3 mb-3 mb-lg-4" }, [
            _createElementVNode("h3", { class: "mb-0" }, "Form Create Vendor"),
            _createElementVNode("a", {
              class: "btn btn-danger fw-semibold text-white px-3",
              type: "button",
              href: "/master/vendor"
            }, [
              _createElementVNode("i", { class: "ri-arrow-drop-left-line text-gray-light" }),
              _createTextVNode(" Back To List Vendor ")
            ])
          ], -1)),
          (isLoading.value)
            ? (_openBlock(), _createBlock(BaseLoading, {
                key: 0,
                text: "Processing Data..."
              }))
            : _createCommentVNode("", true),
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 1,
                onSubmit: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_unref(onSubmit) && _unref(onSubmit)(...args))),
                class: "row g-3 needs-validation form"
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _cache[6] || (_cache[6] = _createElementVNode("label", {
                        for: "name",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vendor Name "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_8, [
                        _withDirectives(_createElementVNode("input", {
                          name: "name",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(name) ? (name).value = $event : null)),
                          placeholder: "Vendor Name",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(name)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(errors).name), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _cache[7] || (_cache[7] = _createElementVNode("label", {
                        for: "address",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Vendor Address "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          name: "address",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(address) ? (address).value = $event : null)),
                          placeholder: "Vendor Address",
                          type: "text",
                          class: "form-control text-dark"
                        }, null, 512), [
                          [_vModelText, _unref(address)]
                        ])
                      ]),
                      _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(errors).address), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[9] || (_cache[9] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Email "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          name: "email",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_isRef(email) ? (email).value = $event : null)),
                          placeholder: "Email",
                          type: "email",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(email)]
                        ]),
                        _cache[8] || (_cache[8] = _createElementVNode("i", {
                          class: "ri-mail-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(errors).email), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _cache[10] || (_cache[10] = _createElementVNode("label", {
                        for: "username",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Phone Code "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createVNode(_unref(vSelect), {
                        options: listPhoneCode,
                        name: "phone_code",
                        modelValue: _unref(phone_code),
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(phone_code) ? (phone_code).value = $event : null)),
                        placeholder: "Phone Code"
                      }, null, 8, ["modelValue"]),
                      _createElementVNode("span", _hoisted_20, _toDisplayString(_unref(errors).phone_code), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createElementVNode("div", _hoisted_22, [
                      _cache[12] || (_cache[12] = _createElementVNode("label", {
                        for: "phone_number",
                        class: "form-label label text-secondary"
                      }, [
                        _createTextVNode("Phone Number "),
                        _createElementVNode("span", { class: "text-danger" }, "*")
                      ], -1)),
                      _createElementVNode("div", _hoisted_23, [
                        _withDirectives(_createElementVNode("input", {
                          name: "phone_number",
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(phone_number) ? (phone_number).value = $event : null)),
                          placeholder: "81217018168",
                          type: "text",
                          class: "form-control text-dark ps-5"
                        }, null, 512), [
                          [_vModelText, _unref(phone_number)]
                        ]),
                        _cache[11] || (_cache[11] = _createElementVNode("i", {
                          class: "ri-phone-line position-absolute top-0 start-0 fs-20 text-gray-light ps-20",
                          style: {"top":"5px !important"}
                        }, null, -1))
                      ]),
                      _createElementVNode("span", _hoisted_24, _toDisplayString(_unref(errors).phone_number), 1)
                    ])
                  ]),
                  _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-12 mt-5" }, [
                    _createElementVNode("button", {
                      class: "btn btn-primary fw-semibold text-white py-2 px-3",
                      type: "submit"
                    }, " Save ")
                  ], -1))
                ])
              ], 32))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}
}

})